module.exports = __webpack_public_path__ + "static/Alianza-7cbd88427b0b85e5f747077ae4922973.jpg";